import { type Enum } from '@webapp/utils'

export const DpsRequestStatuses = {
  PENDING: 0,
  SUCCESS: 1,
  FAIL: 2,
  ABANDONED: 3,
} as const

export type DpsRequestStatus = Enum<typeof DpsRequestStatuses>
